<template>
  <BackupPage />
</template>

<script setup lang="ts">
import BackupPage from "shared-ui/pages/BackupPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    layout: "AppLayout",
  },
});
</script>
